import { Injectable } from '@angular/core';
import {EeocDataV2, TalentMoatsAvailabilityV2} from "../../../../typings";
import {TalentProfileStartAvailability} from "../../../enums";

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor() { }

  getDateFormat(localeId: number): string {
    const formats: { [countryId: number]: string } = {
      1: 'MM/dd/yyyy', // USA
      2: 'dd/MM/yyyy', // uk english
      3: 'dd/MM/yyyy', // australia english
      4: 'yyyy/MM/dd', // canada french
      24: 'yyyy/MM/dd', // canada english
      21: 'dd/MM/yyyy', // netherlands english
    };

    return formats[localeId] || 'MM/dd/yyyy';
  }

}
